const BLUE_STOPS = [
    [0, '#F1F9FC'],
    [0.2, '#DAEBF3'],
    [0.4, '#C2DEEA'],
    [0.6, '#ABD1E1'],
    [0.8, '#94C4D8'],
    [1, '#7CB7CF'],
];

const RED_STOPS = [
    [0, '#FFF4F5'],
    [0.2, '#FFE1E2'],
    [0.4, '#FECED0'],
    [0.6, '#FABBBE'],
    [0.8, '#F4A9AD'],
    [1, '#EF969C'],
];

const BLUE_RED_STOPS = [
    [0, '#C1DCFA'],
    [1 / 6, '#DBEBFC'],
    [2 / 6, '#EEF5FE'],
    [0.5, '#FAFAFA'],
    [4 / 6, '#FEEEEE'],
    [5 / 6, '#FBDDDD'],
    [1, '#FCC9C9'],
];

const RATING_STOPS = [
    [0, '#C1DCFA'],
    [0.25, '#EEF5FE'],
    [0.5, '#FAFAFA'],
    [0.75, '#FEEEEE'],
    [1, '#FCC9C9'],
];

const reversed = (stops) =>
    stops.map(([stop, color]) => [1 - stop, color]).reverse();

export const COLOR_SCALES = {
    blue: BLUE_STOPS,
    blue_reversed: reversed(BLUE_STOPS),
    red: RED_STOPS,
    red_reversed: reversed(RED_STOPS),
    blue_red: BLUE_RED_STOPS,
    red_blue: reversed(BLUE_RED_STOPS),
    rating: RATING_STOPS,
};

const toChannels = (hex) => [
    parseInt(hex.slice(1, 3), 16),
    parseInt(hex.slice(3, 5), 16),
    parseInt(hex.slice(5, 7), 16),
];

const toHex = (channels) =>
    `#${channels
        .map((channel) =>
            Math.round(channel).toString(16).padStart(2, '0').toUpperCase()
        )
        .join('')}`;

export const scaleColor = (stops, position) => {
    const clamped = Math.min(1, Math.max(0, position));
    const upper = stops.findIndex(([stop]) => stop >= clamped);

    if (upper === -1) {
        return stops[stops.length - 1][1];
    }

    if (upper === 0) {
        return stops[0][1];
    }

    const [lowStop, lowColor] = stops[upper - 1];
    const [highStop, highColor] = stops[upper];
    const ratio = (clamped - lowStop) / (highStop - lowStop);
    const low = toChannels(lowColor);
    const high = toChannels(highColor);

    return toHex(
        low.map((channel, index) => channel + (high[index] - channel) * ratio)
    );
};
